module.exports = "/_next/static/images/6bad315b48700626bda00edd48b7c1a5-apple-pay.png";